import i18n from 'i18next';

import {apiClient} from 'core/apiClient';
import {COUNTRY, COUNTRY_NAMING} from 'core/constants/env';
import {ApiFilters, ApiPaging, SimplePaginationContent, ApiSortings} from 'types/api';
import {GtinsGridRawRow, GtinUploadDataItem} from 'types/gtins';

const GTINS_URL = '/service/product-cards';
const GTIN_UPLOAD_URL = '/service/load/product-cards/new';

export async function fetchGtinsGrid(params: {
    paging: ApiPaging;
    filters: ApiFilters;
    sortings: ApiSortings;
}): Promise<SimplePaginationContent<GtinsGridRawRow>> {
    const result: GtinsGridRawRow[] = (await apiClient.post(GTINS_URL, params)).data;

    if (result.length > params.paging.pageSize) {
        return {
            content: result.slice(0, -1),
            hasNext: true,
        };
    }

    return {
        content: result,
        hasNext: false,
    };
}

export async function uploadGtinApiV2(data: Array<GtinUploadDataItem>) {
    return (
        await apiClient.post(
            GTIN_UPLOAD_URL,
            {products: data},
            {
                baseURL: 'api/v2',
                headers: {'Customer-Language': i18n.language},
                params: {customer: COUNTRY},
            },
        )
    ).data;
}

export async function editGtinApiV2(gtin: number) {
    return (
        await apiClient.get<{fields: Record<string, any>}>(`service/product-cards/${gtin}`, {
            baseURL: 'api/v2',
            headers: {'Customer-Language': i18n.language},
            params: {customer: COUNTRY},
        })
    ).data;
}

export async function recallGtin({gtin, reason}: {gtin: string; reason: string}) {
    return (
        await apiClient.post(
            `marking/dropout/gtin`,
            {
                baseURL: 'api/v1',
                headers: {'Customer-Language': i18n.language},
                params: {customer: COUNTRY},
            },
            {
                params: {gtin, reason},
            },
        )
    ).data;
}

export async function deleteGtinApiV2(gtin: number) {
    return (
        await apiClient.delete(`service/product-cards/${gtin}`, {
            baseURL: 'api/v2',
            headers: {'Customer-Language': i18n.language},
            params: {customer: COUNTRY_NAMING.short},
        })
    ).data;
}
